import React from "react";
import { connect } from "react-redux";
import { obtenerDocumentoCombinacionPlanMovilidad } from "../actions";
import { dataLayerTag } from "../functions";

class DocumentoMedidasAcciones extends React.PureComponent {
  render() {
    return (
      <div>
          <div className="row">
            <div className="col-sm-9 text-left">
              <div className="PM-cuadro-3">
                <h5><strong>Documento de medidas y acciones</strong></h5>
                <p>Descarga el documento con las medidas y las acciones que te proponemos para implementar tu Plan de Movilidad en el centro de trabajo.</p>
              </div>
            </div>
            <div className="col-sm-3 btn-material">
              <button
                style={{ margin: 5 }}
                className="btn PM-dx-button-plan PM-dx-button-plan-100 PM-button-light"
                onClick={() => {
                  this.props.dispatch(obtenerDocumentoCombinacionPlanMovilidad(this.props.idplanMovilidad));
                  // gtd -> descarga documento con combinaciones
                  dataLayerTag({
                    'event': 'etapa_3_descarga_documentos_medidas_acciones',
                    'etapa': '3'
                  });
                }}
                disabled={this.props.estadoProceso < 3 || this.props.isLoadingDocumento}
              >Ver documento
              </button>
            </div>
          </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  idplanMovilidad: state.planMovilidad.idplanMovilidad,
  estadoProceso: state.planMovilidad.estadoProceso,
  isLoadingDocumento: state.planMovilidad.isLoadingDocumento,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(DocumentoMedidasAcciones);
